export default "__VITE_ASSET__2bf33a46__"